import React, { useState, useEffect } from 'react';
import Header from './Header';
import Marketing from './Marketing';
import Products from './Products';
import Footer from './Footer';
import PopupFeedback from './PopupFeedback';
import CurrentUserContext from '../contexts/CurrentUserContext';
import { CartProvider } from '../contexts/cardContext';
import { BASE_URL } from '../utils/config';

function App() {
  const [user, setUser] = useState(null);
  const [menu, setMenu] = useState({ groups: [], products: [] }); // безопасно по умолчанию
  const [showPopupFeedback, setShowPopupFeedback] = useState(false);

  useEffect(() => {
    fetchMenuData();
  }, []);

  const fetchMenuData = async () => {
  try {
    const response = await fetch(`${BASE_URL}/nomenclature`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
      mode: 'cors',
    });

    if (!response.ok) {
      throw new Error(`Ошибка сервера: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    setMenu(data);
  } catch (error) {
    console.error('Ошибка при загрузке меню:', error);
  }
  };

  return (
    <CurrentUserContext.Provider value={{ user, setUser }}>
      <CartProvider menu={menu.products || []}>
        <div className="app">
          <Header onOpenFeedback={() => setShowPopupFeedback(true)} />
          <Marketing />
          <Products groups={menu.groups || []} products={menu.products || []} />
          <Footer onOpenFeedback={() => setShowPopupFeedback(true)} />
          <PopupFeedback isOpen={showPopupFeedback} onClose={() => setShowPopupFeedback(false)} />
        </div>
      </CartProvider>
    </CurrentUserContext.Provider>
  );
}

export default App;
